export default "__VITE_ASSET__B3u_nr6Q__"